import qs, { ParsedQs } from 'qs';
import { useLocation } from '@reach/router';

const useQueryParams = (): ParsedQs => {
    const { search } = useLocation();
    return qs.parse((search || '').replace('?', ''));
};

export default useQueryParams;
